// leaf-town - every level, drawn in text.
//  # ground   = one-way ledge   ^ v spikes   % cracked (bash)   ~ crumbles   1 2 blinking   w liquid
//  P start  C checkpoint  E exit  S spring  o token  * leaf  H coffee  T sign  M/V moving platform (| = end of track)
//  b bug  a spiky bug  t typo  f flaky  l/L lint  g logger  m mimic  n noodle  s leak  h heisenbug  r racer  d drone
//  p pendulum  O gear  Q rolling gear  i drip  F fire jet  B boss
// Horizontal levels are built from segments that are bottom-aligned and joined left to right.
(function () {
  'use strict';
  const G = window.G;
  // rows + n rows of solid ground underneath
  const seg = (rows, ground) => {
    const w = rows.reduce((m, r) => Math.max(m, r.length), 0), out = rows.map((r) => r.padEnd(w, ' '));
    for (let i = 0; i < (ground === undefined ? 3 : ground); i++) out.push('#'.repeat(w));
    return out;
  };
  // rows + n rows of ground with a hole from column a to b
  const pit = (rows, a, b, n) => {
    const s = seg(rows, 0), w = s[0].length;
    for (let i = 0; i < n; i++) s.push('#'.repeat(a) + ' '.repeat(b - a + 1) + '#'.repeat(w - b - 1));
    return s;
  };
  const join = (...segs) => {
    const h = Math.max(...segs.map((s) => s.length)), out = Array(h).fill('');
    for (const s of segs) { const w = s[0].length, pad = h - s.length; for (let i = 0; i < h; i++) out[i] += i < pad ? ' '.repeat(w) : s[i - pad]; }
    // headroom: open sky above the tallest thing, and never shorter than the screen
    const sky = Math.max(4, 15 - h);
    for (let i = 0; i < sky; i++) out.unshift(' '.repeat(out[0].length));
    return out;
  };
  const L = (G.LEVELS = {});

  // =====================================================================
  // WORLD 1 - THE SOURCE TREE
  // =====================================================================
  L['1-1'] = {
    world: 1, name: 'hello_world.py', blurb: "print('hello, world'). Then squash the first few bugs.",
    signs: [
      'MOVE with the [ARROWS] and JUMP with [Z] or [SPACE] - hold it to go higher.',
      'Bugs. Swipe them with [X] - or simply land on them.',
      'Between two walls? Jump at one, then jump again. Your friend has grippy feet.',
      'Land on a flying bug, or hold [DOWN] and swipe in mid-air, to bounce off it.',
    ],
    map: join(
      seg(['             ooo      ', '                      ', '  P    T              ']),
      seg(['          oo            ', '        ####            ', '     #######    o o     ', '  ##########            ', '############   #########', '############   #########', '############   #########'], 0),
      seg(['         ooo              ', '                          ', '   T       b        b     ']),
      seg(['                  *         ', '                            ', '               =====        ', '                            ', '         ====          ooo  ', '                            ', '   ====               ====  ', '        b                   ']),
      seg(['          oo    oo      ', '                        ', '         ====  ====     ', '  C                     ', '#######            #####', '#######^^^^^^^^^^^^#####', '########################'], 0),
      seg(['                    ##   ##   ', '                    ## * ##   ', '                    ##   ##   ', '                    ##   ##   ', '                    ##   ##   ', '                    ##   ##   ', '                              ', '                              ', '      t      t   T            ']),
      seg(['              *             ', '                            ', '                            ', '                            ', '              f             ', '                            ', '   T                 b      ']),
      seg(['     ooo            ', '                    ', '  b        b    E   '])
    ),
  };
  L['1-2'] = {
    world: 1, name: 'branching_out.js', blurb: 'feature/branching: mind the gap between branches.',
    signs: ['Up the shaft: jump into a wall, then jump again. And again.'],
    map: join(
      seg(['        ooo         ', '                    ', '  P            b    ']),
      seg(['               *              ', '        o   o       o         ', '                              ', '                              ', '#### M       |  M       | ####', '####                      ####', '####                      ####'], 0),
      seg(['     ##             ', '     ##             ', '     ##             ', '     ##    #########', '     ##  o #########', '     ##    #########', '     ##  o #########', '     ##    #########', '         o #########', '  T        #########']),
      seg(['          ooo             ', '                 f        ', '                          ', '     a          a     C   '], 10),
      seg(['####   V       *      ', '####                  ', '####         =====    ', '####                  ', '####                  ', '####                  ', '####   |          b   ']),
      seg(['        o       o       o       ', '               l                ', '                                ', '###   M      |    M      |   ###', '###^^^^^^^^^^^^^^^^^^^^^^^^^^###', '################################'], 0),
      seg(['            *                 ', '                              ', '          =====               ', '                   f          ', '     ====                     ', '                  ====        ', '   a                    E     '])
    ),
  };
  L['1-3'] = {
    world: 1, name: 'the_linter.rb', blurb: 'The linter has opinions. All of them are red.',
    signs: ['The linter is strict down here. Stay off the red squiggles.', 'A spring. Land on it.'],
    map: join(
      seg(['         ooo        ', '                    ', '   P   T      t     ']),
      seg(['############################', '          vvv       vvv     ', '                            ', '    o        o         o    ', '                            ', '#####^^^#######^^^##########', '############################', '############################'], 0),
      seg(['              ########', '         o    ########', '              ########', '         o    ########', '              ########', '   T     S    ########']),
      seg(['         l         l      ', '                          ', '  C     a     t      a    '], 9),
      seg(['           *              ', '                          ', '###                       ', '###                       ', '###                       ', '###                       ', '###    o      o           ', '###   SSS    SSS          ', '###^^^###^^^^###^^^^######', '##########################', '##########################'], 0),
      seg(['##############################', '                              ', '                              ', '      L       L       L       ', '                              ', '   o      o       o       o   ', '                              ', '######^^######^^######^^######', '##############################', '##############################'], 0),
      seg(['                  *               ', '                                  ', '               #######            ', '               #######            ', '               ##   ##            ', '               %% * ##            ', '           === ##   ##            ', '               #######            ', '   a      S    #######       E    '])
    ),
  };
  const ARENA = (rows) => ['########################'].concat(rows, ['########################', '########################', '########################']);
  L['1-B'] = {
    world: 1, name: 'NULL', boss: 'null', reward: 'bash', blurb: 'It points at nothing. Dereference at your own risk.',
    map: ARENA(['#                      #', '#                      #', '#                      #', '#                      #', '#                      #', '#                      #', '#    ====      ====    #', '#                      #', '#                      #', '#  P               B   #']),
  };

  // =====================================================================
  // WORLD 2 - DEPENDENCY DEPTHS
  // =====================================================================
  L['2-1'] = {
    world: 2, name: 'npm_install.sh', blurb: 'added 1,402 packages in 3s. 47 vulnerabilities.',
    signs: ['New tool: BASH. Press [C] to dash. It smashes cracked blocks - and bugs.', 'BASH works in mid-air too. Jump, then bash across.'],
    map: join(
      seg(['            ############', '              %%        ', '              %%   ooo  ', '  P    T      %%        '], 13),
      seg(['       ooo                ', '                          ', '    m       b    m   g    '], 13),
      pit(['          *               ', '                          ', '            o o o         ', '                          ', '   T                      '], 8, 13, 13),
      seg(['####                  ', '####                  ', '####    ====          ', '####              g   ', '####            ######', '####      o           ', '####     ====         ', '####              H   ', '####            ====  ', '####    n             ']),
      seg(['############################', '##########   *   ###########', '##########       ###########', '##########%%%%%%%###########', '                            ', '                            ', '  C      m         n        ']),
      seg(['      o     o      o          ', '                              ', '                         g    ', '####   M         |    ########', '####wwwwwwwwwwwwwwwwww########', '##############################'], 0),
      seg(['                 *            ', '                              ', '                ###      E    ', '           m    ###   ########', '          ###   ###   ########', '          ###   ###   ########', '    ###   ###   ###   ########', '    ###   ###   ###   ########'])
    ),
  };
  L['2-2'] = {
    world: 2, name: 'left_pad.js', blurb: 'left_pad was unpublished. Everything that depends on it falls.',
    signs: ['These packages were unpublished. They crumble when you stand on them.'],
    map: join(
      seg(['       ooo          ', '                    ', '  P   T       n     ']),
      seg(['       o  o  o  o  o          ', '                              ', '#####~~~~~~~~~~~~~~~~~~~~#####', '#####                    #####', '#####                    #####'], 0),
      seg(['              ~~  ########', '         ~~       ########', '                  ########', '    ~~      f     ########', '                  ########']),
      seg(['          ##########        ', '          #   *    %        ', '  C       #        %   n    '], 8),
      seg(['              *               ', '#####                         ', '#####   ~~                    ', '#####         ~~              ', '#####               ~~~       ', '#####                         ', '#####wwwwwwwwwwwwwwwwww#######', '##############################', '##############################'], 0),
      seg(['##############################', '                              ', '     o  o  o       o  o  o    ', '   n        g  m        n     ']),
      seg(['         *                  ', '                        E   ', '              ~~    ########', '                    ########', '         ~~         ########', '                    ########', '    ~~              ########', '            t       ########'])
    ),
  };
  L['2-3'] = {
    world: 2, name: 'version_hell.lock', blurb: 'Dependency hell goes down, not across. Bash through the floor.',
    signs: ['The way on is DOWN. Jump, hold [DOWN] and press [C] to bash through the cracked floor.'],
    map: [
      '##########################',
      '#                        #',
      '#                        #',
      '#  P   T                 #',
      '####################%%%###',
      '####################%%%###',
      '#                        #',
      '#        o o o           #',
      '#                        #',
      '#   m          b      b  #',
      '###%%%####################',
      '###%%%####################',
      '#                        #',
      '#                    ooo #',
      '#           g            #',
      '#        #####      =====#',
      '#                     %% #',
      '#     n          a    %%*#',
      '###########%%%%###########',
      '###########%%%%###########',
      '#                        #',
      '#  *                     #',
      '#====                    #',
      '#          f        f    #',
      '#                        #',
      '#      ====      ====    #',
      '#                        #',
      '#  t                  t  #',
      '#####################%%%##',
      '#####################%%%##',
      '#                        #',
      '#      o o o             #',
      '#                        #',
      '#   m      C     m       #',
      '##%%%#####################',
      '##%%%#####################',
      '#                        #',
      '#                        #',
      '#====       ooo          #',
      '#                        #',
      '#      ~~~      ~~~      #',
      '#                      * #',
      '#                        #',
      '#wwwwwwwwwwwwwwwwwwww%%###',
      '#####################%%###',
      '#                        #',
      '#                        #',
      '#        ooooo           #',
      '#                        #',
      '#  n       a        E    #',
      '##########################',
      '##########################',
    ],
  };
  L['2-B'] = {
    world: 2, name: 'MERGE CONFLICT', boss: 'merge', reward: 'agents', blurb: 'CONFLICT (content): both modified everything.',
    map: ARENA(['#                      #', '#                      #', '#                      #', '#                      #', '#                      #', '#                      #', '#                      #', '#   ====        ====   #', '#                      #', '#           P          #']),
  };

  // =====================================================================
  // WORLD 3 - THE HEAP
  // =====================================================================
  L['3-1'] = {
    world: 3, name: 'malloc.c', blurb: 'malloc() without free(). Mind the puddles.',
    signs: ['New tool: FIREFLIES. Coins and squashed bugs fill the meter. When it is full, press [V].'],
    map: join(
      seg(['        ooo           ', '                      ', '  P    T       s      ']),
      seg(['##############################', '    i      i       i     i    ', '                              ', '                              ', '         o        o           ', '                s             ', '#####www####www#######www#####', '##############################', '##############################'], 0),
      seg(['              *             ', '                            ', '       o      o      o      ', '                            ', '                        s   ', '####  M           |  #######', '####wwwwwwwwwwwwwwwww#######', '############################'], 0),
      seg(['                      *   ', '                          ', '                    ===== ', '                          ', '            ####          ', '            ####          ', '      ###   ####          ', '  C   ###   ####          ']),
      seg(['##############################', '      p            p          ', '                              ', '                              ', '                              ', '           o          o       ', '                              ', '########www########www########', '##############################', '##############################'], 0),
      seg(['############################', '      i       i      i      ', '                            ', '                            ', '        o       o      o    ', '                            ', '####~~~~wwww~~~~wwww~~~~####', '####wwwwwwwwwwwwwwwwwwww####', '############################'], 0),
      seg(['  ##   ##                     ', '  ## * ##                     ', '  ##   ##                     ', '  ##   ##                     ', '  ##   ##                     ', '  ##   ##         ooo         ', '                              ', '                              ', '        s     s      s    E   '])
    ),
  };
  L['3-2'] = {
    world: 3, name: 'dangling_ptr.c', blurb: 'Pointers, dangling. Do not stand under them.',
    signs: [],
    map: join(
      seg(['       ooo          ', '                    ', '  P        s        ']),
      seg(['##############################', '           p       p          ', '                              ', '                              ', '                              ', '                              ', '     =====   =====   =====    ', '                              ', '####^^^^^^^^^^^^^^^^^^^^^^####', '##############################', '##############################'], 0),
      seg(['                  ########', '             o    ########', '       L          ########', '             o    ########', '                  ########', '       o          ########', '  C       S       ########']),
      seg(['############################', '       p          p         ', '                            ', '                            ', '                            ', '    s          s        H   '], 10),
      seg(['####   V                  ', '####          L           ', '####                 *    ', '####                ====  ', '####                      ', '####          ====        ', '####   |                  ']),
      seg(['##############################', '         p        p           ', '                              ', '                              ', '                              ', '      o     o     o     o     ', '                              ', '####~~~~~  ~~~~~~~  ~~~~~~####', '####wwwwwwwwwwwwwwwwwwwwww####', '##############################'], 0),
      seg(['                *             ', '                              ', '              =====           ', '                              ', '         ~~~          %%%     ', '                      %*%     ', '    s          s      %%%  E  '])
    ),
  };
  L['3-3'] = {
    world: 3, name: 'stack_overflow.c', blurb: 'The heap is filling up. Climb.', rise: { trigger: 55, speed: 19, top: 5 },
    signs: ['It is rising. Go UP.'],
    map: [
      '##########################',
      '#                        #',
      '#                        #',
      '#   E                    #',
      '########                 #',
      '#                        #',
      '#          ====          #',
      '#                        #',
      '#                        #',
      '#    =====               #',
      '#                        #',
      '#           =====        #',
      '#                    *   #',
      '#                        #',
      '#                  ===== #',
      '#                        #',
      '#           =====        #',
      '#                        #',
      '#      t                 #',
      '#    =====               #',
      '#                        #',
      '#            =====       #',
      '#                      * #',
      '#                        #',
      '#                    ====#',
      '#                        #',
      '#                 ~~     #',
      '#        l               #',
      '#             ~~         #',
      '#                        #',
      '#      =====             #',
      '#                        #',
      '#             =====      #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#       *                #',
      '#                        #',
      '#                  C  S  #',
      '#                 ====== #',
      '#            s           #',
      '#   ##   =====           #',
      '#   ##                   #',
      '#   ##                   #',
      '#   ##                   #',
      '#   ##                   #',
      '#   ##                   #',
      '#   ##                   #',
      '#                        #',
      '#========                #',
      '#                        #',
      '#           =====        #',
      '#                        #',
      '#                        #',
      '#                  ===== #',
      '#                        #',
      '#           =====        #',
      '#                        #',
      '#   =====                #',
      '#                        #',
      '#  P                T    #',
      '##########################',
      '##########################',
      '##########################',
    ],
  };
  L['3-B'] = {
    world: 3, name: 'THE LEAK', boss: 'leak', reward: 'sudo', blurb: 'It has been growing since the first deploy.',
    map: ARENA(['#                      #', '#                      #', '#                      #', '# ===              === #', '#        ======        #', '#                      #', '#                      #', '# ====            ==== #', '#                      #', '#  P               B   #']),
  };

  // =====================================================================
  // WORLD 4 - THREAD TOWER
  // =====================================================================
  L['4-1'] = {
    world: 4, name: 'async_await.ts', blurb: 'await platform.exists(); // sometimes', blink: 1.5,
    signs: ['New tool: SUDO. Press jump again in mid-air.', 'await... these blocks only exist half the time. Watch the rhythm.'],
    map: join(
      seg(['       ooo            ', '                      ', '  P    T              ']),
      seg(['             #############', '         o   #############', '             #############', '         o   #############', '             #############']),
      pit(['   T                        ', '#######11112222111122#######'], 7, 20, 7),
      seg(['            *             ', '                          ', '                          ', '                          ', '         ooo              ', '                          ', '    r            r    C   '], 8),
      seg(['                      *       ', '                              ', '                    2222      ', '                              ', '             1111             ', '        O                     ', '      2222                    ', '                         r    '], 8),
      pit(['       o     o     o          ', '                              ', '       Q           |          ', '####111122221111222211112222##'], 4, 27, 7),
      seg(['           *              ', '                          ', '         11111            ', '                          ', '                          ', '    h              E      '], 8)
    ),
  };
  L['4-2'] = {
    world: 4, name: 'race_condition.go', blurb: 'Two threads enter. The order they leave in is undefined.', platSpeed: 72,
    signs: ['Heisenbugs only move when nobody is looking at them. Look at them.'],
    map: join(
      seg(['        ooo         ', '                    ', '  P        r        ']),
      seg(['               *                ', '                                ', '        o       o       o       ', '               O                ', '                                ', '###   M      |    M      |   ###', '###                          ###', '###                          ###'], 0),
      seg(['##########################', '                          ', '      o    o    o    o    ', '                          ', '  C  T  h          h      ']),
      seg(['                  r           ', '                ########      ', '        r       ########      ', '      ########  ########      ', '      ########  ########      ']),
      seg(['              h               ', '     o        o        o      ', '                              ', '   Q        |    Q        |   ']),
      seg(['                 *              ', '                                ', '       |        ====     |      ', '                                ', '                                ', '                                ', '       V          O      V      ', '####                        ####', '####                        ####', '####                        ####'], 0),
      seg(['            *             ', '                          ', '                          ', '                          ', '       ooo                ', '                          ', '    h      r        E     '])
    ),
  };
  L['4-3'] = {
    world: 4, name: 'deadlock.rs', blurb: 'Everyone is waiting for everyone else. Climb anyway.', blink: 1.5,
    signs: ['A deadlock: everything waits on everything else. Do not wait. Climb.'],
    map: [
      '##########################',
      '#                        #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#  E                     #',
      '#######                  #',
      '#                     *  #',
      '#        =====           #',
      '#                        #',
      '#               =====    #',
      '#                        #',
      '#                        #',
      '#         |   11112222####',
      '#                        #',
      '#                        #',
      '#                        #',
      '#              O         #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#         V              #',
      '#                        #',
      '#  =====                 #',
      '#                        #',
      '#         Q       |      #',
      '#         =========      #',
      '#                        #',
      '#                        #',
      '#   *                    #',
      '#                        #',
      '#                     ####',
      '#           O            #',
      '#                2222    #',
      '#                        #',
      '#          1111   h      #',
      '#                        #',
      '#   C                    #',
      '#########                #',
      '#           |            #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#                        #',
      '#           V            #',
      '#                        #',
      '#                  ===== #',
      '# *                      #',
      '#           2222         #',
      '#                        #',
      '#    1111                #',
      '#                        #',
      '#  P       T             #',
      '##########################',
      '##########################',
      '##########################',
    ],
  };
  L['4-B'] = {
    world: 4, name: 'INFINITE LOOP', boss: 'loop', reward: 'opus', blurb: 'while (true) { } - somebody forgot the exit condition.',
    map: ARENA(['#                      #', '#                      #', '#                      #', '#                      #', '#         ====         #', '#                      #', '#                      #', '#  ====          ====  #', '#                      #', '#  P                   #']),
  };

  // =====================================================================
  // WORLD 5 - PRODUCTION
  // =====================================================================
  L['5-1'] = {
    world: 5, name: 'hotfix_friday.sh', blurb: 'Never deploy on a Friday. It is Friday.', blink: 1.4,
    signs: ['Production. Everything is on fire. This is fine.'],
    map: join(
      seg(['        ooo         ', '                    ', '  P    T            ']),
      seg(['               *              ', '                              ', '                              ', '      o      o       o        ', '                              ', '     F    F         F    F    ', '##############www##############', '##############################', '##############################'], 0),
      seg(['       d            d       ', '                            ', '                            ', '      o     o     o    o    ', '                            ', '####~~~~~  ~~~~~~  ~~~~~####', '####wwwwwwwwwwwwwwwwwwww####', '############################'], 0),
      seg(['          ooo             ', '                          ', '  C   H     a    r    a   ']),
      seg(['             *                ', '                     #########', '                     #########', '            2222     #########', '                     #########', '      1111           #########', '   F             F   #########']),
      seg(['              d               ', '                              ', '       ooo            ooo     ', '                              ', '    g       m     n       g   '], 9),
      seg(['#####                         ', '#####                         ', '#####    ====           *     ', '#####                         ', '#####           ====          ', '#####                         ', '#####wwwwwwwwwwwwwwwwwwww#####', '##############################', '##############################'], 0),
      seg(['         d          d         ', '                              ', '      o      o      o         ', '                              ', '    F    a    F    a    F   E '])
    ),
  };
  L['5-B'] = {
    world: 5, name: 'THE MONOLITH', boss: 'mono', blurb: 'legacy.c - 400,000 lines. Do not touch. It works.',
    map: ARENA(['#                      #', '#                      #', '#                      #', '#                      #', '#                      #', '#       ====           #', '#                      #', '#  ====       =====    #', '#                      #', '#  P                   #']),
  };

  G.NODES = ['1-1', '1-2', '1-3', '1-B', '2-1', '2-2', '2-3', '2-B', '3-1', '3-2', '3-3', '3-B', '4-1', '4-2', '4-3', '4-B', '5-1', '5-B'];
  for (const id of G.NODES) L[id].id = id;
})();

